<template>
  <el-popover
    v-model="visible"
    :disabled="disabledValue"
    :placement="placement"
    :width="width"
    trigger="click"
    @hide="aoutShowFun(false)"
    @show="aoutShowFun(true)"
  >
    <div slot="reference" class="popover_input">
      <p :class="showValue ? 'active' : ''">
        {{ showValue ? showValue : placeholder }}
      </p>
      <i :class="isShowUl ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
    </div>
    <div>
      <div v-show="isAddPage" v-loading="loading">
        <div class="search_div">
          <el-input
            v-model="searchValue"
            :clearable="searchClearable"
            :placeholder="searchPlaceholder"
            prefix-icon="el-icon-search"
            @input="searchData"
          ></el-input>
          <i class="el-icon-circle-plus" @click="addNewData(false)"></i>
        </div>
        <ul v-if="option.length" v-loading="ulLoading" class="option_ul">
          <li
            v-for="(item, index) in option"
            :key="index"
            :class="active === item.id ? 'hover' : ''"
            @click="handleClick(item)"
          >
            <span class="leftspan">{{ item[leftLabel] }}</span>
            <span :title="item[rightLabel]" class="rightspan">
              {{ item[rightLabel] }}
            </span>
          </li>
        </ul>
        <p v-else class="empty_p">暂无数据</p>
      </div>
      <div v-show="!isAddPage" class="add_new_div">
        <div class="add_head_div">
          <i class="el-icon-arrow-left" @click="addNewData(true)"></i>
          <span>新增种类</span>
          <i class="el-icon-close" @click="addNewData(true)"></i>
        </div>
        <div v-show="!isSubmit" v-loading="ulLoading" class="newadd_div">
          <el-input v-model="addValue" placeholder="请输入种类名称"></el-input>
          <p>Tips：新增种类须通过审核后才能使用。</p>
          <el-button class="submit_but" type="primary" @click="submitDate">
            提交
          </el-button>
        </div>
        <div v-show="isSubmit" class="success">
          <el-button circle icon="el-icon-check" type="success"></el-button>
          <span>已提交</span>
          <p>审核结果将以短信形式通知您，请耐心等候</p>
        </div>
      </div>
    </div>
  </el-popover>
</template>
<script>
export default {
  name: "originalSelect",
  props: {
    default_showValue: {
      type: String,
      default: "",
    },
    // 下拉框展示方向
    placement: {
      type: String,
      default: "bottom-start",
    },
    // 需要绑定的值
    backDate: {
      type: [Number, String],
      request: true,
    },
    // 选中数据取对应的key
    keyName: {
      type: String,
      default: "id",
    },
    // 下拉框数组
    optionList: {
      type: Array,
      request: true,
    },
    // 下拉框左边的Label的key
    leftLabel: {
      type: String,
      request: true,
    },
    // 下拉框右边的Label的key
    rightLabel: {
      type: String,
      request: true,
    },
    // 数据加载loading
    loading: {
      type: Boolean,
      default: false,
    },
    // 是否显示清空快捷键
    clearable: {
      type: Boolean,
      default: false,
    },
    searchClearable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请输入",
    },
    searchPlaceholder: {
      type: String,
      default: "请输入",
    },
    width: {
      type: Number,
      default: 304,
    },
  },
  data() {
    return {
      disabledValue: false,
      visible: false,
      showValue: "",
      searchValue: "",
      addValue: "",
      isShowUl: false,
      isAddPage: true,
      active: null,
      gridData: [],
      ulLoading: false,
      isSubmit: false,
      option: [],
    };
  },
  watch: {
    default_showValue(news) {
      this.disabledValue = true;
      this.showValue = news;
    },
    optionList: {
      handler(val) {
        this.optionList = val;
        this.option = val;
      },
      immediate: true,
    },
  },
  created() {
    console.log(this.default_showValue);
  },
  methods: {
    aoutShowFun(val) {
      this.isShowUl = val;
      this.option = JSON.parse(JSON.stringify(this.optionList));
      this.$emit("update:backisShowDate", val);
      if (!this.isShowUl) {
        this.reseData();
      }
    },
    clearDataFun() {
      this.showValue = "";
      this.active = null;
      // 仅返回数据对应的id
      this.$emit("update:backDate", "");
      // 仅返回整个选中数据对象
      this.$emit("backObjData", null);
    },
    reseData() {
      this.searchValue = "";
      this.isShowUl = false;
      this.isAddPage = true;
      this.addValue = "";
      this.isSubmit = false;
    },
    addNewData(val) {
      this.isAddPage = val;
      this.addValue = "";
      this.isSubmit = false;
      this.showValue = "";
      this.active = null;
    },
    handleClick(parems) {
      const { keyName, leftLabel } = this;
      this.active = parems[keyName];
      this.showValue = parems[leftLabel];
      // 仅返回数据对应的id
      this.$emit("update:backDate", parems[keyName]);
      // 仅返回整个选中数据对象
      this.$emit("backObjData", parems);
      this.visible = false;
    },
    submitDate() {
      // 得获取父组件请求的结果
      this.ulLoading = true;
      this.$emit("addNewkind", this.addValue, (res) => {
        this.isSubmit = res;
        this.ulLoading = false;
      });
    },
    searchData(val) {
      this.ulLoading = true;
      if (!val) {
        this.option = JSON.parse(JSON.stringify(this.optionList));
      } else {
        let list = JSON.parse(JSON.stringify(this.optionList));
        const { leftLabel, rightLabel } = this;
        this.option = list.filter((item) => {
          if (item[rightLabel]) {
            return (
              item[leftLabel].includes(val) || item[rightLabel].includes(val)
            );
          } else {
            return item[leftLabel].includes(val);
          }
        });
      }
      this.ulLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.search_div {
  position: relative;
  padding-bottom: 10px;

  i {
    position: absolute;
    right: 10px;
    top: 13px;
    cursor: pointer;
    color: #64c3a4;
  }
}

.option_ul {
  list-style: none;
  padding: 6px 0;
  margin: 0;
  box-sizing: border-box;
  max-height: 150px;
  overflow-y: auto;

  li {
    font-size: 14px;
    padding: 0 20px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #606266;
    height: 34px;
    line-height: 34px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }

  li:hover {
    background-color: #f5f7fa;
  }

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: rgba(0, 0, 0, 0.2);
    margin-right: 5px;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
    border-radius: 0;
    background: rgba(0, 0, 0, 0);
    margin-right: 5px;
  }
}

.empty_p {
  text-align: center;
  color: #d3dce6;
  padding: 0 10px;
}

.hover {
  background-color: #f5f7fa;
  color: #64c3a4 !important;
}

.add_new_div {
  height: 218px;
}

.add_head_div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px;
}

.newadd_div {
  padding-top: 30px;
  text-align: center;

  p {
    text-indent: 0;
    color: #9fa0a0;
    font-size: 14px;
    line-height: 22px;
    margin: 8px 0 30px;
    text-align: left;
  }
}

.submit_but {
  width: 200px;
}

.success {
  text-align: center;
  padding-top: 30px;

  span {
    color: #64c3a4;
    font-size: 18px;
    display: block;
    padding-top: 20px;
  }

  p {
    color: #9fa0a0;
    font-size: 14px;
    line-height: 24px;
    margin: 14px 0;
  }
}

.popover_input {
  width: 100%;
  height: 40px;
  line-height: 40px;
  position: relative;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding: 0 15px;
  box-sizing: border-box;

  p {
    color: #c0c4cc;
  }

  i {
    position: absolute;
    right: 9px;
    top: 13px;
    color: #c0c4cc;
    transition: all 0.3s;
  }

  .active {
    color: #666;
  }
}

.leftspan {
  padding-right: 8px;
}

.rightspan {
  color: #c0c4cc;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: right;
  flex: 1;
}
</style>
<style lang="scss"></style>
